export function addUsers(users) {
	return {
				type: 'GENERAL_ADD_USERS',
				payload:users
			}
}
export function addScript(src) {
    return {
        type: 'GENERAL_ADD_SCRIPT',
        payload:src
    }
}
export function setGlobalKey(key,value) {
	return {
				type: 'GENERAL_SET_GLOBAL_KEY',
				payload:{key,value}
			}
}

export function addNotificationMessage(value) {
	return {
				type: 'GENERAL_ADD_MESSAGE',
				payload:value
			}
}

export function setSetting(key,value) {
	return {
				type: 'GENERAL_SET_SETTING',
				payload:{key,value}
			}
}

export function setOpenConversation(num) {
    return {
        type: 'GENERAL_SET_OPEN_CONVERSATIONS',
        payload:num
    }
}

export function setUnreadMessages(num) {
    return {
        type: 'GENERAL_SET_UNREAD_MESSAGES',
        payload:num
    }
}



// WEBPACK FOOTER //
// ./actions/General.js